import {BrowserRouter as Router, Routes, Route, Navigate} from 'react-router-dom';
import './App.css';
import Login from './components/pages/auth/Login';
import Register from './components/pages/auth/Register';
import ProjectsList from './components/pages/projects/ProjectsList';
import CreateProject from './components/pages/projects/create/CreateProject';
import ProjectView from './components/pages/projects/view/ProjectView';
import ProjectStats from './components/pages/projects/stats/ProjectStats';
import Editor from './components/pages/projects/editor/Editor';
import ProtectedRoute from './components/common/ProtectedRoute';
import Devices from './components/pages/devices/Devices';
import Products from './components/pages/products/Products';
import Settings from './components/pages/settings/Settings';
import Commands from './components/pages/commands/Commands';

function App() {
  return (
    <Router>
      <Routes>
        <Route path='/login' element={<Login />} />
        <Route path='/register' element={<Register />} />
        <Route path='/projects' element={<ProtectedRoute><ProjectsList /></ProtectedRoute>} />
        <Route path='/projects/create' element={<ProtectedRoute><CreateProject /></ProtectedRoute>} />
        <Route path='/project/:id' element={<ProtectedRoute><ProjectView /></ProtectedRoute>} />
        <Route path='/project/:id/stats' element={<ProtectedRoute><ProjectStats /></ProtectedRoute>} />
        <Route path='/project/:id/editor' element={<ProtectedRoute><Editor /></ProtectedRoute>} />
        <Route path='/project/:id/products' element={<ProtectedRoute><Products /></ProtectedRoute>} />
        <Route path='/project/:id/commands' element={<ProtectedRoute><Commands /></ProtectedRoute>} />
        <Route path='/devices' element={<ProtectedRoute><Devices /></ProtectedRoute>} />
        <Route path='/settings' element={<ProtectedRoute><Settings /></ProtectedRoute>} />
        <Route path='*' element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
}

export default App;
